import { useEffect, useState } from "react";
import { auth0Client } from "src/auth0";

interface Auth0Profile {
	name?: string | undefined;
}

// getUser() reads the SDK's cached profile — no network call once logged in.
// picture isn't used: Auth0 has no real photo for Entra-federated accounts
// (would need a separate Auth0 Action + Graph API permission), so its
// `picture` claim is just a generated placeholder, no better than Gravatar.
export const useAuth0Profile = () => {
	const [profile, setProfile] = useState<Auth0Profile>({});

	useEffect(() => {
		let cancelled = false;
		void auth0Client
			.getUser()
			.then((user) => {
				if (cancelled || !user) return;
				setProfile({ name: user.name });
			})
			.catch(() => {});
		return () => {
			cancelled = true;
		};
	}, []);

	return profile;
};
